import { compose, isEmpty, isNil, omitBy } from 'lodash';

/*
 * Used to build the nested structure of the form data via Check API for
 * formik initial values
 */
export const checkEmployeeFormInitialValues = parameters =>
  parameters.reduce((parameterInitialValues, parameter) => {
    parameterInitialValues[parameter.name] = parameter.value;
    return parameterInitialValues;
  }, {});

export const formatEmployeeWithholdingPayload = fieldValues =>
  Object.keys(omitBy(fieldValues, compose(isNil, isEmpty))).map(key => ({
    name: key,
    value: fieldValues[key],
  }));

export const i18nInfoContent = (onFile, isButtonHidden) => {
  if (onFile && isButtonHidden) {
    return 'team.employee_profile.tax_information.info_content.edit_mode_on_file';
  }

  return onFile
    ? 'team.employee_profile.tax_information.info_content.on_file'
    : 'team.employee_profile.tax_information.info_content.not_on_file';
};
